import { ActionType } from "../constants/instruments";


export const instrumentsAction = instrument => dispatch => {
  return dispatch({
    type: ActionType.OPEND_DRAW_INSTRUMENT,
    payload: instrument
  });
};
